import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

function DrawerTitle({ children }) {
	return (
		<Box sx={{ minWidth: 0 }}>
			<Typography
				variant="heading6"
				sx={{
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
			>
				{children}
			</Typography>
		</Box>
	);
}

DrawerTitle.propTypes = {
	children: PropTypes.any,
};

export default React.memo(DrawerTitle);
